import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * PageTitle Props
 * @property {String} title - title of the Page
 * @property {Node} children - additional children, which commonly include subtitle.
 * @property {Object} className - additional class names for title
*/

export interface PageTitleProps {
  title: ReactNode;
  children?: ReactNode;
  className?: Parameters<typeof classNames>[0];
}

export function PageTitle(props: PageTitleProps) {
  const {
    title, children, className,
  } = props;

  return (
    <div className="page-title-container">
      <section className="page-title">
        <div className="row main-title">
          <h1 className={classNames('type-bold', 'col-sm-12', className)}>
            {title}
          </h1>
        </div>
        {children}
      </section>
    </div>
  );
}

PageTitle.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

PageTitle.defaultProps = {
  className: '',
  children: null,
};
